import { Connection } from '@solana/web3.js';
import { Program, Provider } from '@project-serum/anchor';
import { idl } from '@dialectlabs/web3';
export function createDialectProgram(walletAdapter, dialectProgramAddress, rpcUrl) {
    const dialectConnection = new Connection(rpcUrl, {
        commitment: 'recent',
    });
    const dialectProvider = new Provider(dialectConnection, walletAdapter, Provider.defaultOptions());
    return new Program(idl, dialectProgramAddress, dialectProvider);
}
//# sourceMappingURL=solana-dialect-program-factory.js.map